import { Component, OnInit, ViewEncapsulation, Input, Output, EventEmitter, ChangeDetectorRef, OnChanges } from "@angular/core";
import { delay, SharedService } from '../../../shared';
import { THC_CBD_Group, THC_CBD_CardList, ICDCodeMappings, PartnerNamesEnum } from '../../shared';

@Component({
    selector: 'thc-cbd-cards',
    templateUrl: "./thc-cbd-cards.component.html",
    styleUrls: ["./thc-cbd-cards.component.scss"],
    encapsulation: ViewEncapsulation.None
})
export class THCCBDCardsComponent implements OnInit {
    @Input() partnerName: string = "";
    @Input() selectedGroup: THC_CBD_Group;
    @Input() recommendedTexts: any[] = [];
    @Output() onSelectGroup = new EventEmitter<any>();

    dataList: THC_CBD_Group[] = THC_CBD_CardList;

    PartnerNamesEnum = PartnerNamesEnum;

    constructor(private sharedService: SharedService,
        private cd: ChangeDetectorRef) {
    }

    ngOnInit(): void {
        switch (this.partnerName) {
            case PartnerNamesEnum.AVEXTRA:
                let index = this.dataList.findIndex(a => a.Title === "CBD Dominant");
                if (index > -1) {
                    this.dataList.splice(index, 1);
                }
                break;
        }
    }

    getTHCCBDItem(group: THC_CBD_Group, type: string) {
        return group.Title.indexOf(type) > -1;
    }

    checkRecommended(group: THC_CBD_Group) {
        if (!this.recommendedTexts.length) {
            return false;
        }
        let MapTo = [];
        for (var i = 0; i < ICDCodeMappings.length; i++) {
            const icdMap = ICDCodeMappings[i];
            if (this.recommendedTexts.find(a => a.Code === icdMap.Code)) {
                MapTo = icdMap.MapTo;
            }
        }
        return MapTo.indexOf(group.No) > -1;
    }

    selectGroup(group: THC_CBD_Group) {
        this.onSelectGroup.emit(group);
    }

}
